import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";

const CHAPTERS = [
  {
    no: "01",
    title: "The Illusion of Choice",
    body:
      "Three or four parties. A rulebook we did not write, in a language we were never taught. When did the illusion of choice become the shape of freedom?",
  },
  {
    no: "02",
    title: "The Lifetime Grind",
    body:
      "Merit is our favorite story. But if the ladder tilts before we ever place a foot on it, whose life are we actually living — ours, or the one arranged for us?",
  },
  {
    no: "03",
    title: "The Absurd Protest",
    body:
      "The street is a last address. If a citizen must raise their voice there to be heard, something quiet upstream has already given way.",
  },
];

export default function Agitation() {
  return (
    <section
      data-testid="agitation-section"
      className="relative border-t border-white/10 bg-panel py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="mb-16 max-w-3xl md:mb-20">
          <Reveal>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-rebellion">
              Chapter I — Diagnosis
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl uppercase leading-[0.95] tracking-tight text-paper sm:text-5xl md:text-6xl">
              The Reality of the <span className="text-rebellion">Common Citizen</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-3">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.1}>
              <motion.article
                data-testid={`agitation-card-${i + 1}`}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.35, ease: "easeOut" }}
                className="group relative h-full overflow-hidden border-t-4 border-t-rebellion bg-void p-8 md:p-10"
              >
                <span className="pointer-events-none absolute -right-4 -top-8 select-none font-display text-[8rem] leading-none text-white/[0.04] transition-colors duration-500 group-hover:text-rebellion/20">
                  {c.no}
                </span>
                <h3 className="relative mb-4 font-display text-2xl uppercase tracking-tight text-paper">
                  {c.title}
                </h3>
                <p className="relative font-editorial text-lg leading-relaxed text-white/60">
                  {c.body}
                </p>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
